import React, {Component} from 'react';
import $ from 'jquery';

export function SelectProducto(props) {
  const ret =  
    <select className="producto" onChange={event => props.onSelect(event.target.value)} value={props.value}>
      {Config.temporadas[Number(props.temporada)].productos.map( p =>
      <option value={p.id} key={p.id}>{p.descripcion}</option> )}
    </select>;
  return ret;
  }
